export const environment = {
  production: true,
  userAdminPanelApiUrl: "https://verify-users.salicru.com/api"
};
